export enum ContactStatus {
    CONTACT_STATUS_SCANNED = "scanned",
    CONTACT_STATUS_INTERESTED = "swiped",
    CONTACT_STATUS_CONNECTED = "connected",
    CONTACT_STATUS_MEETING = "meeting_accepted",
    CONTACT_STATUS_MEETING_REQUESTED = "meeting_pending",
    CONTACT_STATUS_VIEWED = "viewed",
    CONTACT_STATUS_SESSION_JOINED = "session_joined",
    CONTACT_STATUS_SESSION_WATCHED = "session_watched",
    CONTACT_STATUS_SESSION_STREAMED = "session_streamed",
    CONTACT_STATUS_SESSION_IN_PERSON_SCAN = "session_in_person_scan",
    CONTACT_STATUS_CPF_LINK_CLICKED = "link_clicked",
    CONTACT_STATUS_SMART_BADGE_CONNECTION = "smart_badge_connection",
    CONTACT_STATUS_EXTERNAL_BADGE_SCAN = "external_badge_scan",
    CONTACT_STATUS_COMPANY_INVITE = "company_invite",
    CONTACT_STATUS_QUALIFIED = "qualified"
}
